export default function Receivables() {
    return <>Receivables</>
}